
export const returArrayAnos = () => {
    let date = new Date().getFullYear() - 6;
    let arrayYear = [];
    for (let i = 0; i < 8; i++) {
      arrayYear = [...arrayYear, date + i];
    }
    return arrayYear;
  };